<template>
  <div id="app">
    <Header routeValue="-3"></Header>
    <div class="content">
      <div class="returns_box">
        <div class="returns">
          <div class="title">Return Policy</div>
          <p>Logistics and after-sales specifications</p>
          <h3>1. After-sales application time: </h3>
          <p>within 30 days from the date of delivery of the order.</p>
          <h3>2. After-sales scope</h3>
          <p>(1) Quality problems of ordered goods (including product quality and product underdelivery and missing
            delivery)<br/>
            Note: Relevant documents (clear product problem picture + clear express sheet + detailed problem
            description) should be provided to initiate after-sales service. If the information provided with relevant
            documents is missing, ambiguous, does not match with the applied order, falsification, etc., the Platform
            has the right to reject the goods and refuse to handle the relevant after-sales; The Platform will submit
            the after-sales issues submitted by the merchant to the responsible party for verification and confirmation.
            If the responsible party and the user cannot reach an agreement in a dispute, the Platform will determine
            the liability based on the evidence provided by both parties, and the dispute time will not be included in
            the after-sales working day limitation period.<br/>
            (2) After sales caused by order logistics problems, the responsible party is the logistics carrier, and the
            corresponding logistics provider shall bear the corresponding responsibilities.<br/>
            Note: Due to logistics problems caused by uncontrollable forces (such as epidemic, war, riots, natural
            disasters, flight restrictions and other force majeure factors), the Platform has the right to terminate the
            compensation according to the actual situation and inform the platform.<br/>
            (3) Special note: For problems caused by special circumstances or reasons, Oasisdream platform has the right
            not to assist in providing after-sales service, including but not limited to the following
            circumstances<br/>
            • The products sold on this platform are customized products, which cannot be sold twice, and the products
            sold cannot be returned or exchanged for no reason;<br/>
            • Poor printing results due to the user's own design problems or problems with the pictures used for design
            (such as blurred design elements, etc.);<br/>
            • Normal color difference between real objects and web pictures caused by shooting lighting and different
            display resolutions;<br/>
            • The size and weight of the product, the possible reasonable error as clearly indicated in the product
            details;<br/>
            • Due to incorrect delivery information provided by the user, the logistics cannot be properly
            invested;<br/>
            • The statutory holiday period is relatively long, resulting in delayed production and delivery;<br/>
            • The system has clearly indicated that the product is short of stock, the product is out of stock, etc.,
            and the user still orders and pays for the production and delivery delay;<br/>
            • Violation of illegal patterns, infringement of third-party copyright, etc., and other circumstances that
            do not support the application for after-sales according to laws and regulations or these Rules and
            regulations<br/>
            • Reasonable error range caused by normal production process, such as sewing error, stitching error,
            alignment error and other reasonable error range.
          </p>
          <h3>3. After-sales application process</h3>
          <p>
            (1) The user initiates the after-sales application, fills in the reasons for applying for after-sales
            service and details of the problem, and provides the corresponding after-sales certificate as required.<br/>
            (2) After receiving the after-sales application initiated by the user, the platform will accept the
            application within 15 working days (starting from the user's submission of the application, such as
            weekends, legal holidays, etc., the corresponding delay), and verify and confirm the application problems
            and evidence vouchers submitted by the user.<br/>
            (3) If confirmed, the platform will pass the after-sales application submitted by the user; If there is any
            objection to the after-sales certificate, the platform will determine the result according to the actual
            situation.<br/>
            (4) After the after-sales application is approved, the Platform is expected to return the money to the
            user's account balance on the Platform within 3-7 working days or send the goods again according to the
            user's request.
          </p>
        </div>
      </div>

    </div>
    <Footer style="background: #FFFFFF;color: #666666"></Footer>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'

export default {
  name: 'Returns',
  components: {
    Header,
    Footer,
  },
  data () {
    return {title: '',}
  },
  mounted () {
    window.scrollTo(0, 0)
    this.title = window.location.href
  },
  created () {
  },
  methods: {},
}
</script>
<style scoped lang="less">

.content {
  background: #FFFFFF;

  .returns_box {
    padding: 70px 0;
    margin-top: 20px;

    .returns {
      background: #FFFFFF;
      box-shadow: 0 10px 15px 0 rgba(1, 1, 1, 0.08), 0px -5px 10px 0px rgba(1, 1, 1, 0.05);
      border: 1px solid #E9E5E5;
      padding: 60px;
      margin: 0 260px 0 260px;


      .title {
        text-align: center;
        font-weight: bold;
        font-size: 30px;
        margin-bottom: 56px;
        color: #333333;
      }

      h3 {
        font-weight: bold;
        font-size: 24px;
        color: #333333;
      }

      p {
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        line-height: 24px;
      }
    }
  }

}


</style>



// WEBPACK FOOTER //
// src/views/Returns.vue